export enum ReportTimes {
    DAILY = 'Diário', 
    WEEKLY = 'Semanal', 
    MONTHLY = 'Mensal'
}